// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2t0F2","label":"SetPasswdForm_label__2NBn9"};